import { render, staticRenderFns } from "./MainPoints.vue?vue&type=template&id=c9c13ec6&lang=pug&"
import script from "./MainPoints.vue?vue&type=script&lang=js&"
export * from "./MainPoints.vue?vue&type=script&lang=js&"
import style0 from "./MainPoints.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports